import { render, staticRenderFns } from "./CommunicationTypeEdit.vue?vue&type=template&id=33445b81&"
import script from "./CommunicationTypeEdit.vue?vue&type=script&lang=ts&"
export * from "./CommunicationTypeEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33445b81')) {
      api.createRecord('33445b81', component.options)
    } else {
      api.reload('33445b81', component.options)
    }
    module.hot.accept("./CommunicationTypeEdit.vue?vue&type=template&id=33445b81&", function () {
      api.rerender('33445b81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/communicationTypes/CommunicationTypeEdit.vue"
export default component.exports